// @flow
import { css } from "styled-components";
import { media } from "@nested/brand";
import {
  ScallopedWindowDevice,
  SemiCircleWindowDevice,
} from "@nested/brand/src/icons";

const heroImageStyles = css`
  width: 100%;
  position: relative;
  /* This matches the height to the aspect ratio of the semi-circular frame */
  padding-top: calc(100% * 220 / 439);
  ${media.desktop`
    padding-top: 0;
    width: calc(((100% + 40px)/ 12 * 5) - 40px);
    margin-right: calc(((100% + 40px) / 12));
    align-self: stretch;
  `}
`;

const fillContainer = css`
  box-sizing: border-box;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const innerImageStyle = css`
  ${fillContainer}
  padding: 1px;
  background-clip: content-box;
  background-image: url(${({ src }) => src});
  background-size: cover;
  background-position: center;
`;

const semiCircleImageStyles = css`
  ${fillContainer}
  z-index: 1;
  width: 100%;
  border: 2px solid
    ${({ theme, lightMode }) => (lightMode ? "white" : theme.palette.hague)};
  ${media.desktop`
    display: none;
  `};
`;

const scallopedImageStyles = css`
  display: none;
  ${media.desktop`
    z-index: 1;
    border: 2px solid ${({ theme, lightMode }) =>
      lightMode ? "white" : theme.palette.hague};
    display: block;
    ${fillContainer}
    height: 100%;
    width: 100%;
  `}
`;

export const ImageWindow = ({
  heroImage,
  className,
  lightMode,
}: {
  heroImage: string,
  className?: string,
  lightMode?: boolean,
}) => (
  <div css={heroImageStyles} className={className}>
    <div css={innerImageStyle} src={heroImage} />
    <SemiCircleWindowDevice
      css={semiCircleImageStyles}
      src={heroImage}
      lightMode={lightMode}
      fill={lightMode ? "white" : undefined}
    />
    <ScallopedWindowDevice
      css={scallopedImageStyles}
      src={heroImage}
      lightMode={lightMode}
      fill={lightMode ? "white" : undefined}
    />
  </div>
);
